import React from "react";

import ComingSoon from "components/Common/ComingSoon";

const Accounts = () => {
  return (
    <div>
      <ComingSoon />
    </div>
  );
};

export default Accounts;
